import { Typography } from "@material-tailwind/react";
import React from "react";

interface CustomCardProps {
  title: string | number;
  subtitle: string;
  image: string;
  textColor?: string;
}

const CustomCard: React.FC<CustomCardProps> = ({
  title,
  image: image,
  subtitle,
  textColor,
}) => {
  return (
    <figure className="relative p-3 lg:p-0 w-full">
      <img
        className="rounded-xl object-cover object-center w-full"
        src={image}
        alt={title.toString()}
      />
      <div className="absolute inset-0 flex items-center">
        <div className={` ${textColor} p-4 `}>
          <Typography
            placeholder={undefined}
            className="lg:py-10 m-4 font-light text-3xl"
          >
            {title}
          </Typography>
          <Typography
            placeholder={undefined}
            className="lg:pb-10 m-4 font-semibold text-3xl"
          >
            {subtitle}
          </Typography>
        </div>
      </div>
    </figure>
  );
};

export default CustomCard;
